import AdminService from './AdminService'
export default class Service {
    AdminService = new AdminService();

}
